<template>
    <div class="uploads text-justify">
        <transition-group name="list-uploads" tag="div">
            <div v-bind:key="upload.id" v-for="upload in uploads" class="alert alert-info upload" role="alert">
                <div class="size-container">
                    <small class="size" v-text="sizeForHuman(upload.size)"></small>
                </div>
                <a class="name" v-text="upload.name"></a>
                <a class="progression">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: upload.percent + '%' }"
                            v-bind:aria-valuenow="upload.percent" aria-valuemin="0" aria-valuemax="100">{{upload.percent}}%</div>
                    </div>
                </a>
                <a class="cancel" v-on:click.prevent="removeUpload(upload)">
                    <i class="fas fa-times"></i>
                </a>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        name: "Upload",
        computed: {
            ...mapState("language", ["language"]),
            ...mapState("upload", ["uploads"])
        },
        methods: {
            sizeForHuman: function(bytes) {
                var sizes;
                if (this.language == "fr_FR") {
                    sizes = ["Octets", "Ko", "Mo", "Go", "To"];
                } else {
                    sizes = ["Bytes", "KB", "MB", "GB", "TB"];
                }
                if (bytes === 0) {
                    return "0 Byte";
                } else if (bytes === 1) {
                    return "1 Byte";
                }
                var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
            },
            ...mapMutations("upload", ["removeUpload"])
        }
    }
</script>

<style scoped>
    .upload {
        position: relative;
        display: flex;
        align-items: center;
    }
    .upload .size-container {
        position: absolute;
        /* 259: 400px - 100px (progress bar width) - 41px (padding + times) */
        left: 259px;
        right: 41px;
        bottom: 0;
        height: 20px;
    }
    .upload .size {
        display: block;
        width: 100%;
        text-align: center;
        font-size: 10px;
        padding-top: 2px;
        color: #3786af;
    }
    .upload .name {
        flex: 1;
        display: inline-block;
        color: #3786af;
    }
    .upload .progression {
        width: 100px;
    }
    .upload .progression .progress {
        height: 16px;
        background-color: #aed6e8;
    }
    .upload .progression .progress .progress-bar {
        background-color: #2390c1;
        font-size: 10px;
    }
    .upload .cancel {
        margin-left: 10px;
        color: #3786af;
    }

    .upload .fa-times {
        cursor: pointer;
        -webkit-transition: color .2s ease;
        -moz-transition: color .2s ease;
        -ms-transition: color .2s ease;
        transition: color .2s ease;
    }

    .list-uploads-enter-active, .list-uploads-leave-active {
        -webkit-transition: all 1s;
        -moz-transition: all 1s;
        -ms-transition: all 1s;
        transition: all 1s;
    }
    .list-uploads-enter {
        opacity: 0;
        transform: translateY(30px) scale(1.3);
    }
    .list-uploads-leave-to {
        opacity: 0;
        transform: translateY(-30px) scale(0.7);
    }
</style>